import axios from 'axios';
import UserAuthKey from '../../../../components/Common/UserAuthKey';
import {
  setNotificationLogList,
  setNotificationLogSummary,
  setNotificationQueueList,
  setNotificationQueueSummary,
} from '../../../../Redux/notificationManager/notificationManagerSlice';
import { setUserData } from '../../../../Redux/user/userSlice';

const apiUrl = process.env.REACT_APP_OMS_NEST_API;

const handleAuthError = (error, dispatch) => {
  if (error?.response?.status === 401) {
    dispatch(setUserData(null));
    window.location.replace('/logout');
  }
};

export const fetchNotificationLogList = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}/notification/log/list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: { ...params },
  };
  try {
    const response = await axios(config);
    dispatch(setNotificationLogList(response?.data));
  } catch (error) {
    handleAuthError(error, dispatch);
  }
};

/* Distinct dispatch locations for the log listing dropdown. Kept in component
   state rather than redux - it is read by one filter and nothing else. */
export const fetchNotificationLogFilterOptions = async ({ dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}/notification/log/filter-options`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {},
  };
  try {
    const response = await axios(config);
    return response?.data;
  } catch (error) {
    handleAuthError(error, dispatch);
    return null;
  }
};

export const fetchNotificationLogSummary = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}/notification/log/summary`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: { ...params },
  };
  try {
    const response = await axios(config);
    dispatch(setNotificationLogSummary(response?.data));
  } catch (error) {
    handleAuthError(error, dispatch);
  }
};

export const fetchNotificationQueueList = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}/notification/queue/list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: { ...params },
  };
  try {
    const response = await axios(config);
    dispatch(setNotificationQueueList(response?.data));
  } catch (error) {
    handleAuthError(error, dispatch);
  }
};

export const fetchNotificationQueueSummary = async ({ dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}/notification/queue/summary`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {},
  };
  try {
    const response = await axios(config);
    dispatch(setNotificationQueueSummary(response?.data));
  } catch (error) {
    handleAuthError(error, dispatch);
  }
};
